// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import elementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/css/main.css' // 自定义main 样式表

import appConst from '@/utils/const.js' // 项目通用常量

Vue.config.productionTip = false

// 将通用常量设置为vue的原型属性，在不同的vue实例内，都是不变的
Vue.prototype.APPCONST = appConst

Vue.use(elementUI)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js